import t_19_2276_colorized from './KZ.T.19.2276.svg'
import t_19_2276 from './KZ.T.19.2276 black.svg'

export default [
  t_19_2276_colorized,
  t_19_2276,
]
